let tableDynamic = [];

(function ($) {
  "use strict";
  tableInit();
  menuMarker();
  init();
  core();
})(jQuery);

$.fn.selectpicker.Constructor.BootstrapVersion = "4";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

$(document).scroll(function () {
  var $nav = $(".mainnav");
  $nav.toggleClass("scrolled", $(this).scrollTop() > $nav.height() / 2);
});

if (window.location.hash.substring(0, 8) === "#results") {
  document.querySelector(location.hash).scrollIntoView({ behavior: "smooth" });
  setTimeout(function () {
    history.replaceState(null, null, ' ');
  }, 500);
}

function init() {
  $('form[data-toggle="validator"]').validator();
  $(".dynamic").ajaxFormUnbind();
  $(".dynamic").ajaxForm({
    beforeSend: function (arr, $form, options) {
      $(".loader").show();
    },
    uploadProgress: function (event, position, total, percentComplete) {
      $(".loader div.progress-bar").css("width", percentComplete + "%");
      $(".loader .transfer-percentage").html("% " + percentComplete);
      $(".loader .transfer-progress").html(
        fileSizeNice(position) + "/" + fileSizeNice(total)
      );
    },
    success: function (responseText, statusText, xhr, $form) {
      history.replaceState(null, null, " ");
      if (responseText) {
        $(".loader").hide();
        if ((resp = isJson(responseText))) {
          if (resp.hasOwnProperty("status")) {
            Swal.fire({
              icon: resp.status,
              title: resp.title,
              html: resp.body,
              timer: resp.timer ? resp.timer : false,
              timerProgressBar: resp.timer ? true : false,
              confirmButtonText: stringOk,
              onOpen: (s) => {
                s.addEventListener("mouseenter", Swal.stopTimer);
                s.addEventListener("mouseleave", Swal.resumeTimer);
              },
            }).then(function () {
              // If editUrl is provided and form requested to open edit, open in new tab
              try {
                var shouldOpenEdit = false;
                if ($form && $form.length) {
                  var openEditField = $form.find('input[name="open_edit"]').val();
                  shouldOpenEdit = openEditField === '1';
                }
                if (shouldOpenEdit && resp.editUrl) {
                  window.open(resp.editUrl, '_blank');
                }
              } catch (e) { }
              if (resp.hasOwnProperty("destination")) {
                window.location.href = resp.destination;
              }
            });
          } else if (resp.hasOwnProperty("destination")) {
            window.location.href = resp.destination;
          }
        } else {
          Swal.fire({
            title: stringError,
            icon: "error",
            html: responseText,
          });
        }
      } else {
        location.reload();
      }
    },
  });
  $(".searchForm").ajaxForm({
    beforeSend: function (arr, $form, options) {
      $(".searchButton").html($(".searchButton").data("loading"));
    },
    success: function (xhr) {
      $(".searchButton").html($(".searchButton").data("text"));
      //console.log(xhr);
    },
  });
  $(".dpicker").datetimepicker({
    format: "YYYY-MM-DD",
    focusOnShow: false,
    ignoreReadonly: true,
    useCurrent: false,
  });
  $(".dpicker.linked-min").on("dp.change", function (e) {
    $(".dpicker.linked-max").data("DateTimePicker").minDate(e.date);
  });
  $(".dpicker.linked-max").on("dp.change", function (e) {
    $(".dpicker.linked-min").data("DateTimePicker").maxDate(e.date);
  });
  $(".selectize").selectize({
    plugins: ["remove_button"],
    delimiter: ",",
  });
  $(".creatize").selectize({
    plugins: ["remove_button"],
    delimiter: ",",
    create: true,
    createOnBlur: true,
    persist: false,
    maxOptions: 20,
  });
  $(".trumbowyg").trumbowyg({
    btns: [
      ["viewHTML"],
      ["undo", "redo"],
      ["formatting", "fontsize", "foreColor", "superscript", "subscript"],
      ["strong", "em", "horizontalRule"],
      ["link", "upload"],
      ["table"],
      ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
      ["unorderedList", "orderedList"],
      ["removeformat"],
    ],
    plugins: {
      upload: {
        serverPath: "/a/coreActions/uploadImage",
      },
    },
    svgPath: "/assets/trumbowyg.svg",
    imageWidthModalEdit: true,
  });
  $(".linked").click(function () {
    if ($(this).data("href")) {
      window.location = $(this).data("href");
    }
  });
  $('[data-toggle="tooltip"]').tooltip({
    html: true,
  });
  $('[data-toggle="popover"]').popover();
  $(".selectpicker").selectpicker();

  // On-Page Search
  $(document).on("input", ".on-page-search", function () {
    let that = $(this);
    let val = that.val().toLowerCase();
    let item = that.data("item");
    let all = 0;
    let visible = 0;
    $("." + item).each(function (i, e) {
      all++;
      if ($(this).text().toLowerCase().indexOf(val) === -1) {
        $(this).hide();
      } else {
        $(this).show();
        visible++;
      }
    });
    that.attr("title", visible + " / " + all).attr("data-original-title", visible + " / " + all).tooltip('update').tooltip('show');

  });


}
function core() {
  var clipboard = new ClipboardJS(".clip");
  clipboard.on("success", function (e) {
    Toast.fire({
      icon: "success",
      title: $(e.trigger).data("success"),
    });

    e.clearSelection();
  });
  $("#modal").on("show.bs.modal", function (e) {
    var target = $(e.relatedTarget);
    var modal = $(this);
    modal
      .find(".modal-content-in")
      .load("/m/" + target.data("link"), function () {
        if (typeof e.relatedTarget != "undefined") {
          window.location.hash = $(e.relatedTarget).data("link");
        }
      });

    $(document).off("focusin.modal");
  });
  $("#modal").on("hidden.bs.modal", function (e) {
    $(this)
      .find(".modal-content-in")
      .html(
        '<div class="text-center m-5"><i class="fas fa-spinner fa-pulse fa-5x"></i></div>'
      );
    history.replaceState(null, null, " ");
  });
  $("body").on("click", '[data-action="delete"]', function (e) {
    e.preventDefault();
    $id = $(this).data("id");
    $table = $(this).data("table");
    $crosscheck = $(this).data("crosscheck");
    $return = $(this).data("return");
    Swal.fire({
      title: stringAreYouSure,
      text: stringYouCanNotTakeBack,
      icon: "warning",
      showCancelButton: true,
      showLoaderOnConfirm: true,
      cancelButtonText: stringCancel,
      confirmButtonText: stringDelete,
    }).then(function (result) {
      if (result.value) {
        $.ajax({
          method: "POST",
          url: "/a/coreActions/deleteRow",
          data: {
            table: $table,
            id: $id,
            crosscheck: $crosscheck,
          },
        }).done(function (msg) {
          if (msg) {
            Swal.fire({
              title: stringCantDelete,
              text: stringCantDeleteReason + msg,
              icon: "error",
            }).then(function () {
              history.replaceState(null, null, " ");
            });
          } else {
            Swal.fire({
              title: stringDeleted,
              icon: "success",
              timer: 1500,
            }).then(function () {
              history.replaceState(null, null, " ");
              if ($return) {
                window.location.href = $return;
              } else {
                location.reload();
              }
            });
          }
        });
      }
    });
  });
  $("body").on("click", '[data-action="bulk-delete"]', function (e) {
    e.preventDefault();
    $table = $(this).data("table");
    $key = $(this).data("key");
    $value = $(this).data("value");
    Swal.fire({
      title: stringAreYouSure,
      text: stringBulkDeleteDesc,
      icon: "warning",
      showCancelButton: true,
      showLoaderOnConfirm: true,
      cancelButtonText: stringCancel,
      confirmButtonText: stringDelete,
      preConfirm: () => {
        Swal.getCancelButton().setAttribute("disabled", "");
        return $.ajax({
          method: "POST",
          url: "/a/coreActions/bulkDelete",
          data: {
            table: $table,
            key: $key,
            value: $value,
          },
        })
          .then((response) => {
            return response;
          })
          .catch((error) => {
            Swal.getCancelButton().removeAttribute("disabled");
            swal.showValidationError(`${error}`);
          });
      },
    }).then(function (result) {
      if (result) {
        Swal.fire({
          title: stringOk,
          icon: "success",
          timer: 1500,
        }).then(function () {
          history.replaceState(null, null, " ");
          location.reload();
        });
      }
    });
  });
  $("body").on("click", '[data-action="add-fav"]', function (e) {
    e.preventDefault();
    $this = $(this);
    $id = $this.data("id");
    $successMessage = $this.data("success");
    $loginRequiredMessage = $this.data("error");
    $.ajax({
      method: "POST",
      url: "/a/memberActions/addFav",
      data: {
        iid: $id,
      },
    }).done(function (msg) {
      if (msg == "OK") {
        Toast.fire({
          icon: "success",
          title: $successMessage,
        });
        $('[data-action="add-fav"]').hide();
        $('[data-action="remove-fav"]').show();
      } else {
        Toast.fire({
          icon: "error",
          title: $loginRequiredMessage,
        });
      }

    });
  });
  $("body").on("click", '[data-action="remove-fav"]', function (e) {
    e.preventDefault();
    $this = $(this);
    $id = $this.data("id");
    $successMessage = $this.data("success");
    $.ajax({
      method: "POST",
      url: "/a/memberActions/removeFav",
      data: {
        iid: $id,
      },
    }).done(function (msg) {
      Toast.fire({
        icon: "success",
        title: $successMessage,
      });
      $('[data-action="add-fav"]').show();
      $('[data-action="remove-fav"]').hide();
    });
  });
  $("body").on("change", 'input[type="file"]', function (e) {
    var fileName = e.target.files[0].name;
    $(this).siblings(".custom-file-label").html(fileName);
  });
  $("#mainmenu").on("show.bs.collapse", function () {
    $(".mainnav").addClass("open");
  });
  $("#mainmenu").on("hidden.bs.collapse", function () {
    $(".mainnav").removeClass("open");
  });
  $(".collapse.iconed").on("show.bs.collapse", function () {
    $("a[href='#" + $(this).attr("id") + "']>.toggle").toggleClass(
      "fa-rotate-180"
    );
    localStorage.setItem(
      "collapse_" + window.location.pathname + "_" + this.id,
      true
    );
  });
  $(".collapse.iconed").on("hide.bs.collapse", function () {
    $("a[href='#" + $(this).attr("id") + "']>.toggle").toggleClass(
      "fa-rotate-180"
    );
    localStorage.setItem(
      "collapse_" + window.location.pathname + "_" + this.id,
      false
    );
  });
  $(".collapse").each(function () {
    if (
      localStorage.getItem(
        "collapse_" + window.location.pathname + "_" + this.id
      ) == "true"
    ) {
      $(this).collapse("show");
    }
  });

  $(".switcheroo :input").change(function () {
    $("form").submit();
  });

  $("body").on("click", ".field-cloner", function (event) {
    event.preventDefault();
    var container = $(this).closest(".field-container");
    container
      .clone()
      .find('input:not([type="hidden"]),select,textarea')
      .val("")
      .prop("selected", function () {
        return this.defaultSelected;
      })
      .end()
      .insertAfter(container)
      .find("input,select")
      .removeClass("is-valid is-invalid")
      .end()
      .find(".custom-file-label")
      .text(stringSelectFile)
      .end()
      .find(".clean-on-clone")
      .remove()
      .end()
      .find(".bootstrap-select")
      .replaceWith(function () {
        return $("select", this);
      })
      .end()
      .find(".bs-title-option")
      .remove()
      .find(".selectpicker")
      .selectpicker("render");
    cloneSorter(container);
    $("form").validator("update");
    $(".dpicker").datetimepicker({
      format: "YYYY-MM-DD",
      focusOnShow: false,
      ignoreReadonly: true,
      useCurrent: false,
    });
  });
  $("body").on("click", ".field-mover", function (e) {
    var direction = $(this).data("direction");
    var container = $(this).closest(".field-container");
    if (direction == "up") {
      container.prev().insertAfter(container);
    }
    if (direction == "down") {
      container.next().insertBefore(container);
    }
    cloneSorter(container);
  });
  $("body").on("click", ".field-remover", function (event) {
    event.preventDefault();
    var container = $(this).closest(".field-container");
    Swal.fire({
      title: stringAreYouSure,
      text: stringYouCanNotTakeBack,
      icon: "warning",
      showCancelButton: true,
      showLoaderOnConfirm: true,
      cancelButtonText: stringCancel,
      confirmButtonText: stringDelete,
    }).then(function (result) {
      if (result.value) {
        container.remove();
        $("form").validator("update");
        cloneSorter(container);
      }
    });
  });
  $("body").on("click", ".dynamic-field-adder", function (e) {
    e.preventDefault();
    var item = $(this).data("field");
    var target = $(this).data("target");
    $(".field-pool ." + item)
      .clone()
      .appendTo(target);
    dynamicSorter();
    $("form").validator("update");
    $(".dpicker").datetimepicker({
      format: "YYYY-MM-DD",
      focusOnShow: false,
      ignoreReadonly: true,
      useCurrent: false,
    });
  });
  $("body").on("click", ".dynamic-field-mover", function (e) {
    var direction = $(this).data("direction");
    var that = $(this).closest(".field-block");
    if (direction == "up") {
      that.prev().insertAfter(that);
    }
    if (direction == "down") {
      that.next().insertBefore(that);
    }
    dynamicSorter();
  });
  $("body").on("click", ".dynamic-field-remover", function (e) {
    e.preventDefault();
    var that = $(this);
    var container = that.closest(".field-block");
    Swal.fire({
      title: stringAreYouSure,
      text: stringYouCanNotTakeBack,
      icon: "warning",
      showCancelButton: true,
      showLoaderOnConfirm: true,
      cancelButtonText: stringCancel,
      confirmButtonText: stringDelete,
    }).then(function (result) {
      if (result.value) {
        container.remove();
        $("form").validator("update");
        dynamicSorter();
      }
    });
  });

  if ($("#auto-refresh-10").length > 0) {
    setTimeout(function () {
      window.location.reload(1);
    }, 10000);
  }
}
function cloneSorter(container) {
  container
    .parent()
    .children(".field-container")
    .each(function (index) {
      $(this)
        .find("input,select,textarea,checkbox,label")
        .each(function () {
          $(this).attr({
            name: function (_, name) {
              if (name) {
                return name.replace(/\d+(?!.*\d)/g, index);
              }
            },
            id: function (_, name) {
              if (name) {
                return name.replace(/\d+(?!.*\d)/g, index);
              }
            },
            for: function (_, name) {
              if (name) {
                return name.replace(/\d+(?!.*\d)/g, index);
              }
            },
          });
        });
    });
  $(".selectpicker").selectpicker();
}
function dynamicSorter() {
  $(".dynamic-fields")
    .find(".field-block")
    .each(function (index) {
      $(this)
        .find("input,select,textarea,checkbox,label")
        .each(function () {
          $(this).attr({
            name: function (_, name) {
              if (name) {
                return name.replace(/\d+/, index);
              }
            },
            id: function (_, name) {
              if (name) {
                return name.replace(/\d+/, index);
              }
            },
            for: function (_, name) {
              if (name) {
                return name.replace(/\d+/, index);
              }
            },
          });
        });
    });
}
function tableInit() {

  DataTable.types().forEach(type => {
    DataTable.type(type, 'detect', () => false);
  });

  $("table.table-dynamic:not(.dataTable)").each(function (i) {
    let table = $(this);
    var source = table.data("source");
    var dbtable = table.data("dbtable");
    var key = table.data("key");
    var value = table.data("value");
    var footerSum = table.data("footer-sum");

    tableDynamic[i] = table.DataTable({
      layout: {
        topStart: 'buttons', // 'buttons',
        topEnd: 'search',//'search',
        bottomStart: 'info',
        bottomEnd: 'paging',
        bottom2: 'pageLength',
      },
      stateSave: true,
      autoWidth: true,
      processing: true,
      deferRender: true,
      serverSide: source ? true : false,
      fnInitComplete: function (oSettings, json) {
        $.each(
          oSettings.aoColumns.filter((element) =>
            element.bVisible ? true : false
          ),
          function (i, val) {
            var value = oSettings && oSettings.aoPreSearchCols && oSettings.aoPreSearchCols[val.idx] && oSettings.aoPreSearchCols[val.idx].search;
            if (value && value.length > 0) {
              setTimeout(function () {
                oSettings.oInstance
                  .find("thead tr th:eq(" + i + ") input")
                  .val(value);
                oSettings.oInstance
                  .find("thead tr th:eq(" + i + ") select")
                  .selectpicker("val", value.split(","));
              });

            }
          }
        );

      },
      drawCallback: function (settings) {
        setTimeout(function () {
          $(".selectpicker").selectpicker();
        }, 100);
      },
      footerCallback: footerSum
        ? function (row, data, start, end, display) {
          var api = this.api(),
            data;
          var intVal = function (i) {
            return typeof i === "string"
              ? i.replace(/[\$,]/g, "") * 1
              : typeof i === "number"
                ? i
                : 0;
          };
          total = api
            .column(footerSum, { filter: "applied" })
            .data()
            .reduce(function (a, b) {
              return intVal(a) + intVal(b);
            }, 0);

          $(api.column(footerSum).footer()).html(
            total.toLocaleString("tr-TR")
          );
        }
        : null,
      pagingType: "simple_numbers",
      ajax: source
        ? {
          url: source,
          type: "POST",
          data: {
            dbtable: dbtable,
            key: key,
            value: value,
          },
        }
        : null,
      language: {
        sDecimal: ",",
        sEmptyTable: "Tabloda herhangi bir veri mevcut değil",
        sInfo:
          "_TOTAL_ kayıttan _START_ - _END_ arasındaki kayıtlar gösteriliyor",
        sInfoEmpty: "Kayıt yok",
        sInfoFiltered: "(_MAX_ kayıt içerisinden bulunan)",
        sInfoPostFix: "",
        sInfoThousands: ".",
        sLengthMenu: "Sayfada _MENU_ kayıt göster",
        sLoadingRecords: "Yükleniyor...",
        sProcessing: "İşleniyor...",
        sSearch: "_INPUT_",
        searchPlaceholder: "Arama...",
        sZeroRecords: "Eşleşen kayıt bulunamadı",
        oPaginate: {
          sFirst: "İlk",
          sLast: "Son",
          sNext: "Sonraki",
          sPrevious: "Önceki",
        },
        buttons: {
          excel: "Excel",
          colvis: "Sütun",
        },
        oAria: {
          sSortAscending: ": artan sütun sıralamasını aktifleştir",
          sSortDescending: ": azalan sütun sıralamasını aktifleştir",
        },
      },
      lengthChange: !0,
      lengthMenu: [
        [10, 25, 50, 1000000],
        [10, 25, 50, "Tümü"],
      ],
      buttons: table.data("lean")
        ? []
        : [
          {
            extend: "colvis",
            className: "btn-sm",
          },
          {
            text: 'Sıfırla',
            className: "btn-sm btn-light",
            action: function (e, dt, node, config) {
              dt.search('').columns().search('').draw();
              node.parents(".dataTable")
                .find("thead tr th select")
                .selectpicker("val", "");
              node.parents(".dataTable")
                .find("thead tr th input")
                .val("");
              dt.columns().visible(true);
            }
          }
        ],

    });

    table.find("thead tr th")
      .each(function (col) {
        let that = $(this);
        var title = that
          .text()
          .replace(/\s{2,}/g, " ")
          .trim();
        if (
          that.attr("data-filter") == "select" ||
          that.attr("data-filter") == "multi_select"
        ) {
          let insert =
            '<select class="selectpicker w-100 " data-live-search="true" data-container=".dataTable" data-selected-text-format="count" data-width="auto" title="' +
            title +
            '" ' +
            (that.attr("data-filter") == "multi_select"
              ? ' multiple data-actions-box="true" '
              : "") +
            " onclick='event.stopPropagation()' onmousedown='event.stopPropagation()' ";
          if (that.attr("data-url")) {
            insert += "data-abs-ajax-url='" + that.attr("data-url") + "' ";
          }
          insert += ">";
          let options = isJson(that.attr("data-filter-options"));

          if (options) {
            let literal = true;
            if (Array.isArray(options)) {
              literal = false;
            }
            for (var k in options) {
              insert += '<option value="' + (literal ? k : options[k]) + '">' + options[k] + "</option>";
            }
          }

          insert += "</select>";
          that.find(".dt-column-header").prepend(insert);
          that.find(".dt-column-title").addClass('d-none');
        }
        if (that.attr("data-filter") == "text") {
          that.find(".dt-column-header").prepend(
            '<input type="search" class="form-control border-0 rounded-0 p-0 d-flex" style="" placeholder="' +
            title +
            '" onclick="event.stopPropagation()" onmousedown="event.stopPropagation()"/>'
          );
          that.find(".dt-column-title").addClass('d-none');
        }
        that.attr("title", title);


        that.find("input, select").on(
          "input change",
          throttle(function () {
            let oldPicks = $(this).val();
            if (oldPicks.isArray) {
              oldPicks = oldPicks.join(",");
            }
            tableDynamic[i].column(col + ':visible').search(oldPicks).draw();
          })
        );

      });

  });
}
function menuMarker() {
  $("#mainnav a").removeClass("active");
  $('#mainnav a[href="' + $(location).attr("pathname") + '"]')
    .addClass("active")
    .parent("div.collapse")
    .addClass("show");
}
function fileSizeNice(x) {
  return x > 1048576
    ? (x / 1048576).toFixed(1) + "Mb"
    : x == 1024
      ? "1Mb"
      : (x / 1024).toFixed(1) + "Kb";
}
function isJson(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return false;
  }
}
function throttle(fn, freq) {
  var frequency = freq !== undefined ? freq : 250,
    last,
    timer;

  return function () {
    var that = this,
      now = +new Date(),
      args = arguments;

    if (last && now < last + frequency) {
      clearTimeout(timer);

      timer = setTimeout(function () {
        last = undefined;
        fn.apply(that, args);
      }, frequency);
    } else {
      last = now;
      fn.apply(that, args);
    }
  };
}
function debounce(func, freq) {
  var frequency = freq !== undefined ? freq : 250,
    inDebounce;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(function () {
      func.apply(context, args);
    }, frequency);
  };
}